export class EventModel {
  id: number;
  name: string;
  description: string;
}
